import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useFetchWithBody, usePost } from '../../api/reactQueryCustomHooks';
import {
    Box, Button, Grid, Paper, Typography, FormControl, InputLabel, Select, MenuItem, useMediaQuery, CircularProgress
} from '@mui/material';

import { format, toDate } from 'date-fns';
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory } from '../../constants/enum';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faDownload, faDownLong, faFilter, faInfo, faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ErrorCard, LoadingCard, MainContainer, MUIDataTable, NoDataCard } from '../../components';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { head } from 'lodash';
import { toast } from 'react-toastify';
import { Autocomplete, AutocompleteItem } from '@heroui/react';

export const ALL_COLUMNS = {

    Trn_Date: { label: "Date", group: "none", type: "date" },
    Doc_No3: { label: "Vou.No", group: "none", type: "string" },
    Doc_No: { label: "Chq/Doc.No", group: "none", type: "string" },
    Particular: { label: "Particuler", group: "none", type: "string" },
    Remark: { label: "Narration", group: "none", type: "string" },
    Debit: { label: "Debit Amt.", group: "none", type: "number" },
    Credit: { label: "Credit Amt.", group: "none", type: "number" },
    Balance: { label: "Balance", group: "none", type: "number" },



};

export const getColumns = (groupBy, activeTab, useMktAsMfg = true) => {
    return Object.entries(ALL_COLUMNS)
        .filter(([key, col]) => {
            // Handle SL_Code

            // Handle grouped columns
            if (col.group && col.group !== groupBy) return false;


            return true;
        })
        .map(([key, col]) => ({ key, ...col }));
};
;


const BankNCashBookReport = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { compCode, compName, startDate, endDate } = useSelector((state) => state.company);
    const tableRef = useRef(null);
    const [groupBy, setGroupBy] = useState('none');
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const [columnFilters, setColumnFilters] = useState({
        Trn_Date: '',
        Doc_No3: '',
        Doc_No: '',
        Particular: '',
        Remark: '',
        Debit: '',
        Credit: '',
        Balance: '',
    });

    const [filters, setFilters] = useState({
        dy: 1,
        fromDate: dayjs(startDate).format("YYYY-MM-DD"),//new Date(new Date().setDate(new Date().getDate() - 30)),
        toDate: dayjs(endDate).format("YYYY-MM-DD"),// new Date(),
        vouType: '',
        acId: '',
        otherAcId: '',
    });
    const exportColumnKeys = [
        "Trn_Date",
        "Doc_No",
        "Doc_No",
        "Particular",
        "Remark",
        "Debit",
        "Credit",
        "Balance",
    ];

    const { isError: isErrorModSet, isLoading, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingInwardItem",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings
        }
    })
    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
            setIsUseMfgNoAsMktno(mktSetting)
        }
    }, [modSetting])

    const { data: accounts = [] } = useFetchWithBody({
        url: apiRoute.transactionEntry.getParties,
        queryKey: ['paymentReportAccounts'],
        inputData: { compCode }
    });
    const { data: otherAccData = [] } = useFetchWithBody({
        url: apiRoute.transactionEntry.getOtheraAcc,
        queryKey: ['ReportOtherAccounts'],
        inputData: { compCode }
    });

    
    const selAcBook = useMemo(() => {
        let bookName = "";
        if (accounts && accounts.length > 0) {
            if (filters && filters?.acId != "" && filters?.acId != null) {
                const selAcc = accounts.filter(ele => ele.AC_ID == filters?.acId)
                bookName = selAcc && selAcc.length > 0 ? selAcc[0].AC_DESC : "";
            }
            else {
                setFilters({ ...filters, acId: accounts[0].AC_ID })
                bookName = accounts[0].AC_DESC;
            }
        }
        return bookName;
    }, [filters, accounts])


    const {
        data: reportData = [],
        isPending,
        isError,
        error,
        mutate: fetchReportData
    } = usePost({
        url: apiRoute.transactionEntry.getBankCashData,
        queryKey: ['BankCashbookReport'],
    });

    

    // // Apply column filters to the data
    const filteredData = useMemo(() => {
        if (!reportData.length) return [];
        return reportData.filter(row => {
            return Object.entries(columnFilters).every(([key, value]) => {
                if (!value) return true;
                const rowValue = row[key] || '';
                return String(rowValue).toLowerCase().includes(String(value).toLowerCase());
            });
        });
    }, [reportData, columnFilters]);




    const filteredAndGroupedData = useMemo(() => {
        if (!reportData?.length) return [];


        if (groupBy === 'none') return filteredData;

        /* ================= GROUPING ================= */

        const groupedData = {};


        const getGroupKey = (row) => {
            switch (groupBy) {
                case 'account':
                    return row.AC_DESC || 'Account';

                case 'party':
                    return row.PAc_Desc || 'Party';

                case 'date':
                    return format(new Date(row.Chq_Date), 'yyyy-MM-dd');

                case 'month':
                    return row.YearMonth || 'Unknown Month';

                default:
                    return 'all';
            }
        };

        const initGroup = (row, key) => ({
            groupKey: key,
            // Trn_Date: groupBy === 'date'
            //     ? format(new Date(row.Chq_Date), 'dd-MMM-yyyy')
            //     : groupBy === 'month'
            //         ? format(new Date(row.Chq_Date), 'MMMM yyyy')
            //         : key,
            // AC_DESC: groupBy === 'account' ? row.AC_DESC : key,
            // PAc_Desc: groupBy === 'party' ? row.PAc_Desc : key,
            // BankName: groupBy === 'bank' ? row.BankName : key,
            // YearMonth: groupBy === 'month' ? row.YearMonth : key,
            // Chq_No: 0,
            // Chq_Amt: 0,
            // Remark: "",



            _children: []
        });

        filteredData.forEach(row => {
            const key = getGroupKey(row);

            if (!groupedData[key]) {
                groupedData[key] = initGroup(row, key);
            }

            const group = groupedData[key];

            const add = (field) => {
                group[field] += Number(row[field]) || 0;
            };

            // add('Chq_Amt');


            // Example weighted logic (if needed)
            // if (row.Rate && row.Weight) {
            //     group._rateWeightedSum += Number(row.Rate) * Number(row.Weight);
            //     group._weightSum += Number(row.Weight);
            // }

            group._children.push(row);
        });

        /* ================= FINALIZE ================= */

        return Object.values(groupedData)
            .map(({ _rateWeightedSum, _weightSum, ...rest }) => ({
                ...rest,
                Rate: _weightSum ? _rateWeightedSum / _weightSum : 0
            }))
            .sort((a, b) =>
                String(a.groupKey).localeCompare(String(b.groupKey))
            );

    }, [
        filteredData,
        columnFilters,
        filters,
        groupBy
    ]);





    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };




    const handleSubmit = (e) => {
        e.preventDefault();
        if ((filters.fromDate && filters.fromDate == 'Invalid Date')
            || (filters.toDate && filters.toDate == 'Invalid Date')) {
            toast.error("Invalid From Date / To Date", {
                "position": "top-center"
            })
        }
        else {

            fetchReportData({
                data: {
                    compcode: compCode.join(","),
                    othr_acid: filters.otherAcId || ' ',
                    fromdate: format(filters.fromDate, 'yyyy-MM-dd'),
                    todate: format(filters.toDate, 'yyyy-MM-dd'),
                    ac_id: filters.acId || ' '
                }
            });
        }

        // refetch();
    };

    const handleReset = () => {
        setFilters({
            compCode: compCode.join(","),
            othr_acid: '',
            fromDate: format(startDate, 'yyyy-MM-dd'),// new Date(new Date().setDate(new Date().getDate() - 30)),
            toDate: format(endDate, 'yyyy-MM-dd'),// new Date(),
            ac_id: filters.acId || ''

        });
        setGroupBy("none")

        fetchReportData({
            data: {
                compcode: compCode.join(","),
                pac_id: '',
                fromdate: format(startDate, 'yyyy-MM-dd'),
                todate: format(endDate, 'yyyy-MM-dd'),
                ac_id: filters.acId || ''
            }
        });
    };



    const handleAutoCompleteChange = (value, name) => {
        
        setFilters(prev => ({
            ...prev,
            otherAcId: value || '',
        }));
    };


    // const totals = calculateTotals();

    const getReportTitle = () => {
        return "";
    };


    const headCssStyle = { fontSize: "0.7rem", lineHeight: 1.3, textTransform: "uppercase", backgroundColor: '#f0f0f0', fontWeight: 600, color: '#3c3c3c' }
    const columns = useMemo(() => getColumns(groupBy, "all", isUseMfgNoAsMktno), [isUseMfgNoAsMktno, groupBy]);
    if (isError) {
        return <ErrorCard />
    }
    if (isLoading) {
        return <LoadingCard />
    }
    return (
        <MainContainer
            pageName={`Bank / Cash Book Report`}
            breadcrumbs={["Reports", "Bank / Cash Book"]}

        >
            <Box sx={{
                p: isMobile ? 1 : 3,
                backgroundColor: 'background.default',
                minHeight: '100vh',

            }}>
                {/* Header Section */}

                <Box
                    sx={{
                        position: "relative",

                        display: "flex",

                        flexDirection: {
                            xs: "column",
                            sm: "row",
                        },

                        justifyContent: "space-between",

                        alignItems: {
                            xs: "flex-start",
                            sm: "center",
                        },

                        gap: {
                            xs: 1,
                            sm: 1.5,
                        },

                        mb: 1.2,

                        px: {
                            xs: 1.3,
                            sm: 1.7,
                        },

                        py: {
                            xs: 0.9,
                            sm: 1,
                        },

                        minHeight: 44,

                        overflow: "hidden",

                        // Soft professional background
                        background:
                            "#FFFFFF",

                        border:
                            "1px solid #dbeafe",

                        borderRadius: "9px",

                        boxShadow:
                            "0 2px 7px rgba(15, 23, 42, 0.06)",

                        transition:
                            "all 0.2s ease",

                        "&:hover": {
                            borderColor: "#bfdbfe",

                            boxShadow:
                                "0 3px 10px rgba(37, 99, 235, 0.08)",
                        },

                        // Left blue accent
                        "&::before": {
                            content: '""',

                            position: "absolute",

                            left: 0,
                            top: 0,
                            bottom: 0,

                            width: "4px",

                            background:
                                "linear-gradient(180deg, #2563eb, #60a5fa)",
                        },
                    }}
                >
                    {/* =====================================
        REPORT TITLE
    ====================================== */}

                    <Box
                        sx={{
                            display: "flex",

                            alignItems: "center",

                            minWidth: 0,

                            pl: 0.5,
                        }}
                    >
                        {/* Small indicator */}
                        <Box
                            sx={{
                                width: 7,
                                height: 7,

                                flexShrink: 0,

                                mr: 1,

                                borderRadius: "50%",

                                backgroundColor:
                                    "#2563eb",

                                boxShadow:
                                    "0 0 0 3px rgba(37, 99, 235, 0.10)",
                            }}
                        />

                        <Typography
                            variant="h4"
                            sx={{
                                minWidth: 0,

                                fontSize: {
                                    xs: "0.95rem",
                                    sm: "1.05rem",
                                    md: "1.15rem",
                                },

                                fontWeight: 600,

                                color: "#1e40af",

                                letterSpacing: "-0.25px",

                                lineHeight: 1.3,

                                whiteSpace: {
                                    xs: "normal",
                                    sm: "nowrap",
                                },

                                overflow: "hidden",

                                textOverflow: "ellipsis",
                            }}
                        >
                            {selAcBook}
                        </Typography>
                    </Box>

                    {/* =====================================
        ACTION AREA
    ====================================== */}

                    {reportData.length > 0 && (
                        <Box
                            sx={{
                                display: "flex",

                                alignItems: "center",

                                justifyContent: {
                                    xs: "flex-start",
                                    sm: "flex-end",
                                },

                                flexWrap: "wrap",

                                gap: 0.8,

                                width: {
                                    xs: "100%",
                                    sm: "auto",
                                },

                                flexShrink: 0,

                                // Style any buttons placed here
                                "& .MuiButton-root": {
                                    height: 32,

                                    minHeight: 32,

                                    minWidth: 80,

                                    px: 1.3,

                                    borderRadius: "7px",

                                    fontSize: "12px",

                                    fontWeight: 600,

                                    textTransform: "none",

                                    boxShadow: "none",

                                    transition:
                                        "all 0.2s ease",

                                    "&:hover": {
                                        transform:
                                            "translateY(-1px)",

                                        boxShadow:
                                            "0 2px 6px rgba(15, 23, 42, 0.10)",
                                    },
                                },

                                "& .MuiButton-startIcon": {
                                    marginRight: "5px",

                                    "& svg": {
                                        fontSize: "12px",
                                    },
                                },

                                // Mobile
                                "@media (max-width:600px)": {
                                    "& .MuiButton-root": {
                                        flex: "1 1 auto",
                                    },
                                },
                            }}
                        >
                            {/* Put your report action buttons here */}
                        </Box>
                    )}
                </Box>



                {/* Filters Section */}
                <div className='p-5'>
                    <form onSubmit={handleSubmit}>

                        <Grid
                            container
                            spacing={1.5}
                            alignItems="center"
                            sx={{
                                mb: 1.5,

                                p: {
                                    xs: 1.2,
                                    sm: 1.5,
                                },

                                borderRadius: "10px",

                                background:
                                    "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",

                                border: "1px solid #e2e8f0",

                                boxShadow:
                                    "0 2px 8px rgba(15, 23, 42, 0.05)",

                                // ==========================================
                                // FORM CONTROL
                                // ==========================================
                                "& .MuiFormControl-root": {
                                    width: "100%",
                                },

                                "& .MuiOutlinedInput-root": {
                                    height: 38,

                                    borderRadius: "7px",

                                    backgroundColor: "#ffffff",

                                    fontSize: "13px",

                                    transition: "all 0.2s ease",

                                    "& fieldset": {
                                        borderColor: "#cbd5e1",

                                        transition:
                                            "border-color 0.2s ease, box-shadow 0.2s ease",
                                    },

                                    "&:hover fieldset": {
                                        borderColor: "#94a3b8",
                                    },

                                    "&.Mui-focused fieldset": {
                                        borderColor: "#2563eb",

                                        borderWidth: "1.5px",

                                        boxShadow:
                                            "0 0 0 2px rgba(37, 99, 235, 0.08)",
                                    },

                                    "&.Mui-disabled": {
                                        backgroundColor: "#f1f5f9",
                                    },
                                },

                                // ==========================================
                                // LABEL
                                // ==========================================
                                "& .MuiInputLabel-root": {
                                    fontSize: "14px",

                                    fontWeight: 500,

                                    color: "#475569",
                                },

                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "#2563eb",

                                    fontWeight: 600,
                                },

                                // ==========================================
                                // SELECT
                                // ==========================================
                                "& .MuiSelect-select": {
                                    display: "flex",

                                    alignItems: "center",

                                    minHeight:
                                        "38px !important",

                                    boxSizing: "border-box",

                                    paddingTop:
                                        "0 !important",

                                    paddingBottom:
                                        "0 !important",

                                    fontSize: "13px",

                                    color: "#334155",
                                },

                                // ==========================================
                                // DATE PICKER
                                // ==========================================
                                "& .MuiPickersInputBase-root": {
                                    height: 38,

                                    borderRadius: "7px",

                                    backgroundColor: "#ffffff",

                                    fontSize: "13px",
                                },

                                "& .MuiPickersOutlinedInput-notchedOutline": {
                                    borderColor: "#cbd5e1",

                                    transition:
                                        "border-color 0.2s ease, box-shadow 0.2s ease",
                                },

                                "& .MuiPickersInputBase-root:hover .MuiPickersOutlinedInput-notchedOutline":
                                {
                                    borderColor: "#94a3b8",
                                },

                                "& .MuiPickersInputBase-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline":
                                {
                                    borderColor: "#2563eb",

                                    borderWidth: "1.5px",
                                },

                                // ==========================================
                                // DATE INPUT
                                // ==========================================
                                "& .MuiPickersInputBase-root input": {
                                    fontSize: "13px",

                                    color: "#334155",
                                },
                            }}
                        >

                            {/* =================================================
        FROM DATE
    ================================================= */}

                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={2}
                            >
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                >
                                    <DatePicker
                                        label="From Date"
                                        views={[
                                            "day",
                                            "month",
                                            "year",
                                        ]}
                                        format="DD/MM/YYYY"
                                        value={
                                            filters.fromDate
                                                ? dayjs(
                                                    filters.fromDate
                                                )
                                                : null
                                        }
                                        onChange={(newValue) => {
                                            setFilters(
                                                (prev) => ({
                                                    ...prev,

                                                    fromDate:
                                                        newValue &&
                                                            dayjs(
                                                                newValue
                                                            ).isValid()
                                                            ? dayjs(
                                                                newValue
                                                            ).format(
                                                                "YYYY-MM-DD"
                                                            )
                                                            : null,
                                                })
                                            );
                                        }}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,

                                                InputLabelProps: {
                                                    sx: {
                                                        fontSize:
                                                            "14px",
                                                        fontWeight: 500,
                                                    },
                                                },
                                            },

                                            popper: {
                                                placement:
                                                    "bottom-start",

                                                disablePortal:
                                                    false,

                                                sx: {
                                                    zIndex: 99999,
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            {/* =================================================
        TO DATE
    ================================================= */}

                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={2}
                            >
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                >
                                    <DatePicker
                                        label="To Date"
                                        views={[
                                            "day",
                                            "month",
                                            "year",
                                        ]}
                                        format="DD/MM/YYYY"
                                        value={
                                            filters.toDate
                                                ? dayjs(
                                                    filters.toDate
                                                )
                                                : null
                                        }
                                        onChange={(newValue) => {
                                            setFilters(
                                                (prev) => ({
                                                    ...prev,

                                                    toDate:
                                                        newValue &&
                                                            dayjs(
                                                                newValue
                                                            ).isValid()
                                                            ? dayjs(
                                                                newValue
                                                            ).format(
                                                                "YYYY-MM-DD"
                                                            )
                                                            : null,
                                                })
                                            );
                                        }}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,

                                                InputLabelProps: {
                                                    sx: {
                                                        fontSize:
                                                            "14px",
                                                        fontWeight: 500,
                                                    },
                                                },
                                            },

                                            popper: {
                                                placement:
                                                    "bottom-start",

                                                disablePortal:
                                                    false,

                                                sx: {
                                                    zIndex: 99999,
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>




                            {/* =================================================
     
        ACCOUNT
    ================================================= */}

                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={2}
                            >
                                <FormControl
                                    fullWidth
                                    size="small"
                                >
                                    <InputLabel>
                                        Account
                                    </InputLabel>

                                    <Select
                                        name="acId"
                                        value={filters.acId}
                                        onChange={handleFilterChange}
                                        label="Account"
                                    >


                                        {accounts.map(
                                            (account) => (
                                                <MenuItem
                                                    key={
                                                        account.AC_ID
                                                    }
                                                    value={
                                                        account.AC_ID
                                                    }
                                                >
                                                    {
                                                        account.AC_DESC
                                                    }
                                                </MenuItem>
                                            )
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
    <FormControl fullWidth size="small">
        <Autocomplete
            
            size="sm"
            radius="sm"
            name="otherAcId"
            color="default"
            variant="bordered"
            selectionMode="single"
            showScrollIndicators
            placeholder="-Select-"
            label="Other Account"
            className="w-full text-xs bg-white"
            menuTrigger="input"
            classNames={{
                label:"text-blue-700 font-semibold"
            }}
            isClearable={true}
            isVirtualized
            defaultItems={otherAccData || []}
            onSelectionChange={(e) =>
                handleAutoCompleteChange(e, "otherAcId")
            }
            selectedKey={filters.otherAcId}
        >
            {(item) => (
                <AutocompleteItem
                    key={item.Party_Id}
                    classNames={{ title: "text-xs" }}
                >
                    {item.Party_Name}
                </AutocompleteItem>
            )}
        </Autocomplete>
    </FormControl>
</Grid>


                            {/* =================================================
        ACTION BUTTONS
    ================================================= */}

                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={2}
                            >
                                <Box
                                    sx={{
                                        display: "flex",

                                        alignItems: "center",

                                        justifyContent: {
                                            xs: "flex-start",
                                            sm: "flex-end",
                                        },

                                        gap: 0.8,

                                        width: "100%",
                                    }}
                                >
                                    {/* ==========================
                SHOW BUTTON
            =========================== */}

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        size="small"
                                        disabled={isPending}
                                        startIcon={
                                            isPending ? (
                                                <CircularProgress
                                                    size={14}
                                                    color="inherit"
                                                />
                                            ) : (
                                                <FontAwesomeIcon
                                                    icon={faSearch}
                                                    style={{
                                                        fontSize:
                                                            "11px",
                                                    }}
                                                />
                                            )
                                        }
                                        sx={{
                                            width: {
                                                xs: "50%",
                                                sm: 82,
                                            },

                                            minWidth: {
                                                xs: 0,
                                                sm: 82,
                                            },

                                            height: 36,

                                            px: 1,

                                            borderRadius: "7px",

                                            fontSize: "12px",

                                            fontWeight: 600,

                                            textTransform: "none",

                                            color: "#ffffff",

                                            background:
                                                "linear-gradient(135deg, #2563eb, #1d4ed8)",

                                            boxShadow:
                                                "0 2px 5px rgba(37, 99, 235, 0.20)",

                                            transition:
                                                "all 0.2s ease",

                                            "&:hover": {
                                                background:
                                                    "linear-gradient(135deg, #1d4ed8, #1e40af)",

                                                boxShadow:
                                                    "0 4px 9px rgba(37, 99, 235, 0.25)",

                                                transform:
                                                    "translateY(-1px)",
                                            },

                                            "&:active": {
                                                transform:
                                                    "translateY(0)",
                                            },

                                            "&.Mui-disabled": {
                                                background:
                                                    "#93c5fd",

                                                color: "#ffffff",
                                            },
                                        }}
                                    >
                                        {isPending
                                            ? "Loading"
                                            : "SHOW"}
                                    </Button>

                                    {/* ==========================
                RESET BUTTON
            =========================== */}

                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={handleReset}
                                        startIcon={
                                            <FontAwesomeIcon
                                                icon={faRefresh}
                                                style={{
                                                    fontSize:
                                                        "11px",
                                                }}
                                            />
                                        }
                                        sx={{
                                            width: {
                                                xs: "50%",
                                                sm: 82,
                                            },

                                            minWidth: {
                                                xs: 0,
                                                sm: 82,
                                            },

                                            height: 36,

                                            px: 1,

                                            borderRadius: "7px",

                                            fontSize: "12px",

                                            fontWeight: 600,

                                            textTransform: "none",

                                            textTransform: "none",

                                            backgroundColor: "#eff6ff", border: "1px solid #bfdbfe", color: "#2563eb",

                                            boxShadow:
                                                "0 1px 2px rgba(15, 23, 42, 0.05)",

                                            transition: "all 0.2s ease",

                                            "&:hover": {
                                                backgroundColor: "#dbeafe", borderColor: "#93c5fd", color: "#1d4ed8",
                                                boxShadow:
                                                    "0 2px 5px rgba(15, 23, 42, 0.10)",

                                                transform: "translateY(-1px)",
                                            },

                                            "&:active": {
                                                backgroundColor: "#cbd5e1",

                                                transform: "translateY(0)",
                                            },
                                        }}
                                    >
                                        RESET
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>


                    </form>
                </div>



                {/* Error Message */}


                {/* Data Table Section */}
                <Paper sx={{
                    p: isMobile ? 1 : 1,
                    borderRadius: 3,
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)',
                    backgroundColor: 'background.paper'
                }} ref={tableRef}>
                    {/* Table Header */}


                    {/* Data Table */}
                    {reportData.length > 0 ? (
                        <Box sx={{ width: "100%", overflowX: "auto" }}>
                            <MUIDataTable
                                data={filteredAndGroupedData}
                                dataColumns={columns}
                                reportTitle={`${selAcBook} Report`}
                                orderGroup={groupBy}
                                currency={"all"}
                                filterDate={filters}
                                tradeLabel={`Type: ${selAcBook} `}
                                companyName={compName.join(",")}
                                hideIfZeroKeys={[]}
                                exportColumnKeys={exportColumnKeys}
                                enableHeaderFilter={true}

                            />
                        </Box>
                    ) : (
                        !isPending && (
                            <NoDataCard />
                        )
                    )}
                </Paper>


            </Box>
        </MainContainer>
    );
};

export default BankNCashBookReport;
